import { FC } from 'react';
import useCustomKybRequests from './useCustomKybRequests';
import CustomRequestForm from '../CustomRequestForm';

type Props = {
  vehicleId: string;
  disabled?: boolean;
};

const CustomKybRequests: FC<Props> = ({ vehicleId, disabled }) => {
  const {
    customKybRequests,
    handleCustomRequestsOrderChange,
    addCustomKybRequest,
    updateCustomKybRequest,
    deleteCustomKybRequest,
    isLoading: isLoadingCustomKybRequests,
  } = useCustomKybRequests(vehicleId);

  return (
    <CustomRequestForm
      customRequests={customKybRequests}
      handleCustomRequestsOrderChange={handleCustomRequestsOrderChange}
      addRequest={(values, onSuccess) => {
        addCustomKybRequest(
          {
            vehicleId,
            ...values,
          },
          { onSuccess },
        );
      }}
      updateRequest={(id, values, onSuccess) => {
        updateCustomKybRequest(
          {
            id,
            vehicleId,
            ...values,
          },
          { onSuccess },
        );
      }}
      deleteRequest={(id) => {
        deleteCustomKybRequest({
          id,
          vehicleId,
        });
      }}
      isLoading={isLoadingCustomKybRequests}
      disabled={disabled}
    />
  );
};

export default CustomKybRequests;
